import { ZERO_DEGREE } from "@pdfking/math/constants"
import type { LayerID } from "@pdfking/renderer-api"

import type { Drawable, ImpositionLayout } from "#internal"
import { NO_DATA } from "#internal"

/**
 * `layout` with `draw` hung on it for `layer`, in the frame the node stands in
 * now: turned further later, the drawing turns with it. `on_sheet` hangs it
 * in the sheet's frame instead, for a drawing that reads where things landed.
 */
export const AddDrawing = (
  layout: ImpositionLayout,
  layer: LayerID,
  draw: Drawable,
  on_sheet = false
): ImpositionLayout => {
  const data = layout.data ?? NO_DATA
  return {
    ...layout,
    data: {
      ...data,
      drawings: [
        ...data.drawings,
        { layer, draw, rotation: on_sheet ? undefined : (layout.rotation ?? ZERO_DEGREE) },
      ],
    },
  }
}
